/** 좌측 검색범위 sidebar. */
import React from "react";
import "./theme.css";

const SCOPES = [
  { key: "all", label: "통합검색" },
  { key: "tariff", label: "관세율표" },
  { key: "precedents", label: "분류사례" },
  { key: "notes", label: "주·해설" },
  { key: "laws", label: "관련법령" },
];

export default function SearchScopeFilter({
  active = "all",
  counts = {},
  onSelect,
}) {
  return (
    <div
      className="audit-root"
      style={{
        width: 200,
        padding: "16px 12px",
        borderRight: "1px solid var(--audit-border)",
        background: "var(--audit-bg-subtle)",
        height: "100%",
      }}
    >
      <h3
        style={{
          fontSize: 12,
          color: "var(--audit-text-muted)",
          textTransform: "uppercase",
          letterSpacing: 0.5,
          margin: "0 0 10px 6px",
        }}
      >
        검색범위
      </h3>
      {SCOPES.map(({ key, label }) => {
        const c = counts[key];
        const isActive = active === key;
        return (
          <button
            key={key}
            onClick={() => onSelect?.(key)}
            style={{
              width: "100%",
              padding: "6px 8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: isActive ? "var(--audit-accent-bg)" : "transparent",
              color: isActive ? "var(--audit-accent)" : "var(--audit-text)",
              border: "none",
              cursor: "pointer",
              textAlign: "left",
              fontSize: 12,
              borderRadius: 4,
              marginBottom: 2,
              fontFamily: "inherit",
            }}
          >
            <span>{label}</span>
            {c != null && (
              <span
                style={{
                  fontSize: 12,
                  color: "var(--audit-text-faint)",
                  fontFamily: "JetBrains Mono, monospace",
                }}
              >
                {c}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
